<template>
	<view class="comtainer">
		<!-- header -->
		<Header class="header">
			<TopInfo></TopInfo>
		</Header>
		<!-- main -->
		<view class="main">
			<Main>
				<DeviceContainer class="deviceInfo"/>
			</Main>
		</view>
	</view>
</template>

<script setup>
	import Header from "./header/header.vue"
	import Main from "./main/main.vue"
	import TopInfo from "@/pages/router/header/index.vue"
	import DeviceContainer from "@/pages/router/main/index.vue"
</script>

<style scoped lang="scss">
	.deviceInfo {
		margin-top: 100px;
	}
	.comtainer{
		display: flex;
		flex-direction:column;
	}
</style>